import { Pipe, PipeTransform } from '@angular/core';
import { Report } from '../../_models/reports';
import { ListsHelperService } from '../../_services/lists-helper.service';

@Pipe({ name: 'reportSortBy' })

export class ReportSortByPipe implements PipeTransform {
  constructor(private listHelper: ListsHelperService) { }

  transform(reports: Report[], column: string, desc: boolean): any[] {
    if (!reports || reports.length == 0) return [];
    if (!column) return reports;
    if (desc == null) {
      desc = true;
    }
    switch (column) {
      /*case 'reportName': {
        reports.sort(this.listHelper.sortSubPropertyString(column, 'reportName', desc));
        break;
      }*/
      default: {
        reports.sort(this.listHelper.sortProperty(column, desc));
        break;
      }
    }

    return reports;
  }
}
